/**
 * Created by TANKSKE on 9/3/2017.
 */
(function () {
    'use strict';

    angular.module('doclr.login', ['doclr.components.vertalingen', 'doclr.components.loading'])

        .controller('LoginController', function ($scope, $http, $window, $location) {
            $scope.loginModel = {
                username: '',
                password: '',
                twoFACode: undefined,
                praktijk: undefined
            };

            function humanReadableInfoMessage(key) {
                var messages = {
                    wachtwoordGewijzigd: '"login.feedbackChangedPassword" | translate',
                    nieuweUserGeregistreerd: '"login.feedbackRegistredNewUser" | translate'
                };

                if (messages.hasOwnProperty(key)) {
                    return messages[key];
                } else {
                    return key;
                }
            }

            $scope.infoMessage = humanReadableInfoMessage($location.search().infoMessage);
            $scope.loginFailure = false;
            $scope.smsServiceFailure = false;
            $scope.smsNumberServiceFailure = false;

            $scope.aanmelden = function aanmelden() {
                $scope.loginFailure = false;
                $scope.smsServiceFailure = false;
                $scope.smsNumberServiceFailure = false;
                let config = {headers: {}};
                config.headers['D-Session-Token'] = 'PaukeslagBoem';
                $http.post('/api/login', $scope.loginModel, config)
                    .then(function onSuccess(response) {
                        // Handle success
                        var data = response.data;
                        var headers = response.headers;
                        if (headers('Location') === null) {
                            if (data.twoFACodeRequired) {
                                $scope.twoFaCodeRequired = true;
                            } else {
                                $scope.selecteerPraktijk = true;
                                $scope.praktijken = data;
                            }
                        } else {
                            $window.location.href = headers('Location');
                        }
                    }, function onError(response) {
                        // Handle error
                        if (response && response.data && response.data.error === 'errorMessage.2FA.smsservice.not.available') {
                            $scope.infoMessage = undefined;
                            $scope.smsServiceFailure = true;
                            return;
                        }

                        if (response && response.data && response.data.error === 'twofa.service.number.invalid') {
                            $scope.infoMessage = undefined;
                            $scope.smsNumberServiceFailure = true;
                            return;
                        }

                        $scope.infoMessage = undefined;
                        $scope.loginFailure = true;

                    });
            };
        })

        .directive('infoMessage', function () {
            return {
                restrict: 'A',
                template: '<div class="alert alert-success" ng-show="infoMessage">{{infoMessage}}</div>',
                scope: false
            };
        })

        .directive('loginFailureMessage', function () {
            return {
                restrict: 'A',
                template: '<div class="alert alert-danger" ng-show="loginFailure">{{"login.loginFailureMessage" | translate}}</div>',
                scope: false
            };
        })
        .directive('smsServiceFailureMessage', function () {
            return {
                restrict: 'A',
                template: '<div class="alert alert-danger" ng-show="smsServiceFailure">{{"errorMessage.2FA.smsservice.not.available" | translate}}</div>',
                scope: false
            };
        })
        .directive('smsNumberServiceFailureMessage', function () {
            return {
                restrict: 'A',
                template: '<div class="alert alert-danger" ng-show="smsNumberServiceFailure">{{"twofa.service.number.invalid" | translate}}</div>',
                scope: false
            };
        });
})();
